export default __webpack_public_path__ + "static/media/tech.d3b856c8.svg";